import React from 'react';
import _ from 'lodash';

// @flow
export default function withFlux(stores, propsMapper) {
  return FluxedComponent => {
    return class FluxContainer extends React.Component {
      constructor(props) {
        super(props);
        this.state = propsMapper();
        stores.forEach(store => store.subscribe(this.observeStoreChanges));
      }

      componentWillUnmount() {
        stores.forEach(store => {
          store.unsubscribe(this.observeStoreChanges);
          if (store.flush) {
            store.flush();
          }
        });
      }

      observeStoreChanges = () => {
        const propsMapping = propsMapper();

        // Must perform this check to prevent unnecessary re-renders as
        // react do shallow compairson and we can have deeper objects
        if (!_.isEqual(this.state, propsMapping)) {
          this.setState(propsMapping);
        }
      };

      render() {
        return <FluxedComponent {...this.state} {...this.props} />;
      }
    };
  };
}
